import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { AxiosResponse } from 'axios';

import api from '@/utils/api';
import { getSigV4HeadersForGet, isExpiredToken } from '@/utils/cognito';
import { ApiUrl, Constants } from '@/utils/constants';

import alertState from '@/states/alertState';

import { IntroduceInfoResponse } from '@/types/api/mypage/introduceInfo';
import introduceInfoState from '@/states/introduceInfoState';
import useSetLoading from '@/hooks/useSetLoading';

import url from '@/utils/config';

/**
 * 紹介者情報取得APIの呼び出しフック。
 * 紹介制度ページで表示する紹介者情報を取得し、関連stateへ保持する。
 *
 * @returns execute - API実行関数
 */
const useCallAPIGetIntroduceInfo = () => {
  const { startLoading, finishLoading } = useSetLoading();
  const setIntroduceInfo = useSetRecoilState(introduceInfoState);
  const setAlert = useSetRecoilState(alertState);

  const execute = useCallback(async () => {
    try {
      startLoading(ApiUrl.Read.INTRODUCE_INFO);
      const headers = await getSigV4HeadersForGet(ApiUrl.Read.INTRODUCE_INFO);
      const response: AxiosResponse<IntroduceInfoResponse, any> = await api.get(
        ApiUrl.Read.INTRODUCE_INFO,
        headers
      );
      // 後続コンポーネントで共通利用できるよう、取得結果をRecoilへ保存する。
      setIntroduceInfo(response.data);
    } catch (error: any) {
      if (isExpiredToken(error)) {
        // 認証切れ時は紹介ページに留めず、ログインし直せるよう戻す。
        window.location.href = url('/login');
        sessionStorage.clear();
        return;
      }
      // 取得失敗は共通アラートで通知する。
      setAlert({
        isOpen: true,
        apiType: Constants.ApiType.API_GET,
      });
    } finally {
      finishLoading(ApiUrl.Read.INTRODUCE_INFO);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { execute };
};

export default useCallAPIGetIntroduceInfo;
